module.exports = __webpack_public_path__ + "static/create-624357d014990bf04d65d16142c6f100.mp4";